import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { HISTORICAL_URL } from 'app/@common/constants'

export default function SelectYear({...props}) {

    const myProps = {
        urlAjax: HISTORICAL_URL.YEAR,
        placeholder: 'Year',
        isMulti: true,
        icon: { icon: 'calendar' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
